export type TableDensity = 'default' | 'compact';

const LABEL_COLUMN_WIDTH_CLASS: Record<TableDensity, string> = {
  default: 'w-[512px] min-w-[512px] max-w-[512px]',
  compact: 'w-[360px] min-w-[360px] max-w-[360px]',
};

export function getLabelColumnWidthClass(
  density: TableDensity = 'default',
): string {
  return LABEL_COLUMN_WIDTH_CLASS[density] ?? LABEL_COLUMN_WIDTH_CLASS.default;
}

